@if (show) {
  <div class="row">
    <div class="col-12">
      <rask-toggle-panel [label]="label" [defaultExpanded]="true">
        <ng-container>
          <pre lang="xml">{{ message }}</pre>
        </ng-container>
      </rask-toggle-panel>
    </div>
  </div>
}
